import React from 'react';
import { color } from '../../theme';
import { GolfboxTournaments as Tournaments } from '../Golfbox';

export const RegisterGolfboxTournaments = {

  // Internal id of the component
  id: 'golfbox-tournaments',

  // Visible label
  label: 'Golfbox Turnering',

  // Fields the user need to fill out when adding an instance of the component
  fields: [
    {
      name: 'id',
      label: 'Specific kategori',
      default: '0',
      widget: 'string',
      hint: 'Findes som det sidste url-parameter. Fx 1397 i https://sollerodgolf.dk/golfbox-iframe-turnering.html#/customer/330/schedule/2021/1397',
    },
  ],

  // Pattern to identify a block as being an instance of this component
  // pattern: /^rentBuggy (\S+)$/,
  // pattern: /<SplitView size={`([a-zA-Z_\- ]*)`}><div>([\s\S]*)<\/div><div>\n([\s\S]*)\n<\/div><\/SplitView>/,
  pattern: /<GolfboxTournaments id=\{(\d*)\} \/>/,

  // Function to extract data elements from the regexp match
  fromBlock(match) {
    return {
      id: match[1],
    };
  },

  toBlock({ id }) {
    return `<GolfboxTournaments id={${id}} />`;
  },

  // Preview output for this component. Can either be a string or a React component
  // (component gives better render performance)
  toPreview() {
    return (
      <div
        style={{
          width: '100%',
          height: 300,
          background: color.lightgray,
          textAlign: 'center',
          display: 'block',
        }}
      >
        <span style={{ lineHeight: '300px', color: color.brown, display: 'block' }}>Golfbox turnerings oversigt</span>
      </div>
    );
  },
};

export const GolfboxTournaments = Tournaments;
